import PropTypes from 'prop-types';

export default PropTypes.oneOf(['en', 'es', 'fr', 'de']);
